import { Component, OnDestroy, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InstallAction, MdmCommandService, RequestType } from '@rocksoft/mdm-sdk-v2';
import { Subscription } from 'rxjs';
import { AvailableOsUpdate } from '../../../viewmodels/apple/available-os-update.model';

@Component({
  selector: 'ml-install-os-update-modal',
  templateUrl: './install-os-update-modal.component.html',
  imports: [ReactiveFormsModule, FormsModule, FaIconComponent],
})
export class InstallOsUpdateModalComponent implements OnDestroy {
  private readonly commandService = inject(MdmCommandService);
  public readonly modal = inject(NgbActiveModal);

  public udid: string;
  public update: AvailableOsUpdate;
  public installAction: InstallAction;
  public subscription: Subscription | undefined;

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }

  public installUpdate(): void {
    this.subscription = this.commandService
      .queueScheduleOSUpdateCommand({
        udid: this.udid,
        apiVersion: '2.0',
        scheduleOSUpdateCommand: {
          requestType: RequestType.ScheduleOsUpdate,
          updates: [
            {
              productKey: this.update.productKey,
              productVersion: this.update.version,
              installAction: this.installAction,
            },
          ],
        },
      })
      .subscribe(() => {
        // TODO: Show error if something goes wrong?
        this.modal.dismiss();
      });
  }
}
